import React from "react";
import Modal from "../../../shared/Modal";

const ProjectionAssumptionsModal = ({ open, onClose, assumptions }) => {
  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      maxWidth="md"
    >
      <div className="p-6">
        <h2 className="text-lg font-bold mb-4 text-gray-900 dark:text-gray-100">
          Projection Assumptions
        </h2>
        <ul className="mb-4 space-y-2">
          <li className="text-gray-700 dark:text-gray-300">
            <span className="font-semibold">Asset Growth Rate:</span>{" "}
            {assumptions.assetGrowth * 100}% per year
          </li>
          <li className="text-gray-700 dark:text-gray-300">
            <span className="font-semibold">Debt Paydown Rate:</span> $
            {assumptions.annualDebtPayment?.toLocaleString() || "30,000"} per year
          </li>
          <li className="text-gray-700 dark:text-gray-300">
            <span className="font-semibold">Volatility (CI):</span> ±
            {assumptions.volatility * 100}% (used for confidence intervals)
          </li>
        </ul>
        <div className="text-xs text-gray-500 dark:text-gray-400">
          Projected values are based on standard multipliers and do not constitute
          financial advice. Confidence intervals represent a range of possible
          outcomes based on assumed volatility.
        </div>
      </div>
    </Modal>
  );
};

export default ProjectionAssumptionsModal;
